"use-strict";

import authConstants from "../authReducer/authConstants";
import constants from "./standingsConstants";
import initialState from "./standingsState";

const standingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.SET_ALL_STANDINGS: {
      return {
        ...state,
        all: action.payload,
      };
    }
    case constants.CLEAR_ALL_STANDINGS: {
      return {
        ...state,
        all: initialState.all,
      };
    }
    case authConstants.LOGOUT: {
      return initialState;
    }
    default: {
      return state;
    }
  }
};

export default standingsReducer;
